











































import { defineComponent, watch, ref, nextTick } from "@vue/composition-api";
import { Tag } from "element-ui";

export default defineComponent({
  components: {
    [Tag.name]: Tag,
  },
  props: {},
  setup(props, { root }) {
    const chatValue = ref("");
    const textareaInput = ref(null);
    const hasInput = ref(false);

    watch(chatValue, (newValue) => {
      // 当chatValue变化时，判断其是否为空字符串
      hasInput.value = newValue.trim() !== "";
    });

    return {
      chatValue,
      hasInput,
    };
  },
});
